import { connect } from 'react-redux';
import { AUTH_LEVELS } from '../auth/Authorized';
import GenericLoader from '../util/GenericLoader';
import { getAlertsAction } from '../../redux/actions/alerts';

/**
 * Alerts API only works for org admin and higher, so don't render the loader for
 * lower access users
 */
const AlertsLoader = ({ userAuthLevel, fetchFunction }) =>
  userAuthLevel <= AUTH_LEVELS.ORG_ADMIN ? <GenericLoader fetchFunction={fetchFunction} /> : null;

export default connect(
  ({ user: { userAuthLevel } }) => ({
    userAuthLevel,
  }),
  (dispatch) => ({
    fetchFunction: () => dispatch(getAlertsAction()),
  })
)(AlertsLoader);
